import { ReactNode } from 'react';

import { IconManager } from '@speeki/icons';

import { ColumnDefinitionType } from '@components/molecules/ListTable/ListTable';

import { useResponsive } from '@utils/hooks/useResponsive';

import { TableRow, TableTextCell } from './ListTableRow.styled';

interface ListTableRowProps<T extends { id: string }> {
    columns: ColumnDefinitionType<T>[];
    onRowClick?: (id: string) => void;
    rowData: T;
    testId: string;
}

export const ListTableRow = <T extends { id: string }>({
    columns,
    onRowClick,
    rowData,
    testId,
}: ListTableRowProps<T>) => {
    const isMd = useResponsive('md');

    return (
        <TableRow
            data-testid={testId}
            isClickable={!!onRowClick}
            onClick={() => onRowClick?.(rowData.id)}
        >
            {columns.map(({ customFormat, key, ...rest }, index) => (
                <TableTextCell {...rest} data-testid="pO-k4Fu" key={index}>
                    {customFormat
                        ? customFormat(rowData[key])
                        : (rowData[key] as ReactNode)}
                </TableTextCell>
            ))}
            {!isMd && <IconManager icon={'SvgChevronRight24'} size={24} />}
        </TableRow>
    );
};
